/**
 * Interning pool for DXF strings that recur heavily across entities
 * (layer names, linetypes, text-style names, dim-style names). A production
 * DXF with 5000+ entities typically has only 30-50 unique values for these
 * fields; fresh allocations per entity waste ~20-30% of parser heap.
 *
 * Usage:
 *   const pool = new StringPool();
 *   entity.layer = pool.intern(value.trim());
 *
 * The pool is owned by the parse-call scope (one pool per parseDxfDocument
 * call). No global mutation — different files don't share strings, which
 * is deliberate (keeps memory freeable after import).
 */
export class StringPool {
  private readonly pool = new Map<string, string>();

  intern(value: string): string {
    const existing = this.pool.get(value);
    if (existing !== undefined) return existing;
    this.pool.set(value, value);
    return value;
  }

  get size(): number {
    return this.pool.size;
  }
}
